import React from 'react';
import './Navbar.css';

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <h1 className="navbar-logo">Manki Enterprise</h1>
        <ul className="nav-menu">
          <li className="nav-item">
            <a 
              href="/" 
              className="nav-link active"
            >
              About Us
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar; 